// extracted by mini-css-extract-plugin
export var container = "styles-module__container___h8nCV";
export var containerFocused = "styles-module__containerFocused___QsKIV";
export var searchBar = "styles-module__searchBar___dVYbJ";
export var searchInput = "styles-module__searchInput___hLixs";
export var clearButton = "styles-module__clearButton___vs5cQ";
export var searchResultsContainer = "styles-module__searchResultsContainer___TnRRw";
export var icon = "styles-module__icon___kRW_l";